import React, { createContext, useContext, useEffect, useState } from "react";

export const TR = {
  en: {
    nav: { services: "Services", work: "Our Work", about: "About", reviews: "Reviews", quote: "Get a Quote", contact: "Contact", call: "Call Now", admin: "Admin" },
    hero: { badge: "24/7 Road Service", scroll: "Scroll", cta_call: "Call (973) 634-1088", cta_services: "Our Services" },
    marquee: "24/7 HEAVY DUTY ROAD SERVICE — NEWARK, NJ — DIESEL REPAIR — OPEN 7 DAYS —",
    services: { kicker: "What we do", title: "We Provide Services In", sub: "From full engine rebuilds to roadside emergencies — one shop, every fix." },
    about: { kicker: "Who we are", title: "Built For The Long Haul", chapters: [
      { n: "01", t: "Certified Diesel Techs", d: "Our technicians live and breathe heavy-duty diesel. Every repair is done to spec, the first time." },
      { n: "02", t: "Open 7 Days a Week", d: "Breakdowns don't wait for business hours. Neither do we. We're here every single day." },
      { n: "03", t: "24/7 Road Service", d: "Stuck on the shoulder? One call and our mobile unit rolls out — anywhere around Newark, NJ." },
    ] },
    gallery: { kicker: "The proof", title: "Our Work", sub: "Real rigs. Real repairs. Real results." },
    reviews: { kicker: "Word on the road", title: "Drivers Trust Us", sub: "Fleets and owner-operators keep coming back." },
    quote: {
      kicker: "Free estimate", title: "Get a Quote", sub: "Tell us what's wrong. We'll get right back to you.",
      name: "Full name", phone: "Phone", email: "Email (optional)", service: "Service needed",
      selectService: "Select a service", message: "Describe the problem",
      submit: "Request Quote", sending: "Sending...",
      success: "Request sent! We'll call you back shortly.", error: "Something went wrong. Please call us.",
    },
    whatsapp: { label: "Chat on WhatsApp", prefill: "Hi JJ Truck Repair, I need help with my truck." },
    contact: { kicker: "Get back on the road", title: "Talk To Us", callTitle: "Call Now", visit: "Visit The Shop", hoursTitle: "Hours", directions: "Get Directions", email: "Email Us" },
    footer: { rights: "All rights reserved.", tagline: "Heavy-duty truck repair & 24/7 road service in Newark, NJ." },
    admin: { login: "Admin Login", email: "Email", password: "Password", signin: "Sign In", loggingIn: "Signing in..." },
  },
  es: {
    nav: { services: "Servicios", work: "Trabajos", about: "Nosotros", reviews: "Reseñas", quote: "Cotización", contact: "Contacto", call: "Llamar", admin: "Admin" },
    hero: { badge: "Servicio en Carretera 24/7", scroll: "Baja", cta_call: "Llamar (973) 634-1088", cta_services: "Nuestros Servicios" },
    marquee: "SERVICIO DE CARRETERA 24/7 — NEWARK, NJ — REPARACIÓN DIÉSEL — ABIERTO 7 DÍAS —",
    services: { kicker: "Qué hacemos", title: "Brindamos Servicios En", sub: "Desde reconstrucciones de motor hasta emergencias en carretera — un solo taller, todas las soluciones." },
    about: { kicker: "Quiénes somos", title: "Hechos Para El Largo Camino", chapters: [
      { n: "01", t: "Técnicos Diésel Certificados", d: "Nuestros técnicos viven y respiran el diésel de trabajo pesado. Cada reparación se hace bien, a la primera." },
      { n: "02", t: "Abierto los 7 Días", d: "Las averías no esperan al horario de oficina. Nosotros tampoco. Estamos aquí todos los días." },
      { n: "03", t: "Servicio en Carretera 24/7", d: "¿Varado en el arcén? Una llamada y nuestra unidad móvil sale — a cualquier punto cerca de Newark, NJ." },
    ] },
    gallery: { kicker: "La prueba", title: "Nuestros Trabajos", sub: "Camiones reales. Reparaciones reales. Resultados reales." },
    reviews: { kicker: "Lo dicen en la carretera", title: "Los Choferes Confían", sub: "Flotas y operadores siempre regresan." },
    quote: {
      kicker: "Estimado gratis", title: "Pide tu Cotización", sub: "Cuéntanos qué falla. Te contactamos enseguida.",
      name: "Nombre completo", phone: "Teléfono", email: "Correo (opcional)", service: "Servicio que necesitas",
      selectService: "Selecciona un servicio", message: "Describe el problema",
      submit: "Solicitar Cotización", sending: "Enviando...",
      success: "¡Solicitud enviada! Te llamaremos en breve.", error: "Algo salió mal. Por favor llámanos.",
    },
    whatsapp: { label: "Escríbenos por WhatsApp", prefill: "Hola JJ Truck Repair, necesito ayuda con mi camión." },
    contact: { kicker: "Vuelve a la carretera", title: "Contáctanos", callTitle: "Llama Ahora", visit: "Visita El Taller", hoursTitle: "Horario", directions: "Cómo Llegar", email: "Escríbenos" },
    footer: { rights: "Todos los derechos reservados.", tagline: "Reparación de camiones pesados y servicio de carretera 24/7 en Newark, NJ." },
    admin: { login: "Acceso Admin", email: "Correo", password: "Contraseña", signin: "Entrar", loggingIn: "Entrando..." },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("jj_lang");
    if (saved) return saved;
    return (navigator.language || "en").toLowerCase().startsWith("es") ? "es" : "en";
  });

  useEffect(() => {
    localStorage.setItem("jj_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang((l) => (l === "en" ? "es" : "en"));
  const t = TR[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
